import { StateStorage } from 'zustand/middleware'
import { createStore } from '../.'

interface SelectedTabStore {
  selectedTab: number
  setSelectedTab: (index: number) => void
}

export const createSelectedTabStore = (storage: StateStorage) =>
  createStore<SelectedTabStore>(
    storage,
    (set) => ({
      selectedTab: 0,
      setSelectedTab(index) {
        set({ selectedTab: index })
      },
    }),
    {
      persist: {
        name: 'selectedTab',
      },
    }
  )
